import React, { Component } from 'react';
import RequestUrl from '../commonjs/urlConfiger';
import HttpUtil from '../commonjs/httpUtil';
// import PopWindow from './pop';

// import '../commonjs/fontPhoneSize';
import $ from 'jquery';
import '../css/addr.css';

// const SPopWindow = Selectable(PopWindow);
var btnCName = "submitBtn";
window.TVBoxInfo = {};
function Base64() {

    // private property
    let _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

    // public method for encoding
    this.encode = function (input) {
        var output = "";
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        var i = 0;
        input = _utf8_encode(input);
        while (i < input.length) {
            chr1 = input.charCodeAt(i++);
            chr2 = input.charCodeAt(i++);
            chr3 = input.charCodeAt(i++);
            enc1 = chr1 >> 2;
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            enc4 = chr3 & 63;
            if (isNaN(chr2)) {
                enc3 = enc4 = 64;
            } else if (isNaN(chr3)) {
                enc4 = 64;
            }
            output = output +
            _keyStr.charAt(enc1) + _keyStr.charAt(enc2) +
            _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
        }
        return output;
    }

    // public method for decoding
    this.decode = function (input) {
        var output = "";
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        while (i < input.length) {
            enc1 = _keyStr.indexOf(input.charAt(i++));
            enc2 = _keyStr.indexOf(input.charAt(i++));
            enc3 = _keyStr.indexOf(input.charAt(i++));
            enc4 = _keyStr.indexOf(input.charAt(i++));
            chr1 = (enc1 << 2) | (enc2 >> 4);
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
            chr3 = ((enc3 & 3) << 6) | enc4;
            output = output + String.fromCharCode(chr1);
            if (enc3 != 64) {
                output = output + String.fromCharCode(chr2);
            }
            if (enc4 != 64) {
                output = output + String.fromCharCode(chr3);
            }
        }
        output = _utf8_decode(output);
        return output;
    }

    // private method for UTF-8 encoding
    const _utf8_encode = (string) => {
        string = string.replace(/\r\n/g,"\n");
        var utftext = "";
        for (var n = 0; n < string.length; n++) {
            var c = string.charCodeAt(n);
            if (c < 128) {
                utftext += String.fromCharCode(c);
            } else if((c > 127) && (c < 2048)) {
                utftext += String.fromCharCode((c >> 6) | 192);
                utftext += String.fromCharCode((c & 63) | 128);
            } else {
                utftext += String.fromCharCode((c >> 12) | 224);
                utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                utftext += String.fromCharCode((c & 63) | 128);
            }

        }
        return utftext;
    }

    // private method for UTF-8 decoding
    const _utf8_decode = (utftext) => {
        var string = "";
        var i = 0;
        var c1,c2,c3;
        var c = c1 = c2 = 0;
        while ( i < utftext.length ) {
            c = utftext.charCodeAt(i);
            if (c < 128) {
                string += String.fromCharCode(c);
                i++;
            } else if((c > 191) && (c < 224)) {
                c2 = utftext.charCodeAt(i+1);
                string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                i += 2;
            } else {
                c2 = utftext.charCodeAt(i+1);
                c3 = utftext.charCodeAt(i+2);
                string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                i += 3;
            }
        }
        return string;
    }
}
export default class InputAddr extends Component{
	constructor(props) {
        super(props);
        this.state = {
            addrData: [],
            popType: 3,
            errorTips: "",
            nameValue: '',
            phoneValue: '',
            zipCode: '',
            addrValue: '',
            noteValue: '',
            idCardNum:''
        };
	}

	componentDidMount(){
		// keyListener.set(this.handleKeyDown);

		var oBase64 = new Base64();
		window.TVBoxInfo.partnerCode = this.getUrlParam("partnerCode");
		window.TVBoxInfo.token = this.getUrlParam("token");
		window.TVBoxInfo.userid = this.getUrlParam("userId");
		window.TVBoxInfo.macCode = this.getUrlParam("mac");
		window.TVBoxInfo.deMacCode = window.TVBoxInfo.macCode;
		console.log(window.TVBoxInfo.deMacCode);
		// console.log(TVBoxInfo.userid);
		let getAddrUrl = RequestUrl.getUserAddr(window.TVBoxInfo.partnerCode,window.TVBoxInfo.token,window.TVBoxInfo.userid,window.TVBoxInfo.deMacCode);
		this.getAddr(getAddrUrl);
    this.getPingBack(RequestUrl.getPBAppIndex(window.TVBoxInfo.partnerCode,window.TVBoxInfo.macCode,window.TVBoxInfo.userid,"1"));
	}
	getUrlParam = (name) => {
	    var regObj = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	    var matchResult = window.location.search.substr(1).match(regObj);
	    if (matchResult != null) {
	        return decodeURIComponent(matchResult[2]);
	    }
	    return null;
	}
  getPingBack = (url) => {
      HttpUtil.get(url).then((json)=>{
          // console.log('pnl OK!' + json);
      }, (json)=>{
          // console.log('pnl fail!' + json);
      });
  }
	onChange = (event) => {
		if($("input.name").val() === "" || $("input.phone").val() === "" || $("input.zipcode").val() === "" || $("textarea.addr").val() === ""){
			btnCName = "submitBtn";
		}else{
			btnCName = "submitBtn canSub";
		}
		this.setState({
			nameValue: event.target.nameValue,
			phoneValue: event.target.phoneValue,
			zipCode: event.target.zipCode,
			addrValue: event.target.addrValue,
			noteValue: event.target.noteValue,
      idCardNum: event.target.idCardNum,
		});
	}
	onPress = () => {
		if($("input.name").val() === "" || $("input.phone").val() === "" || $("input.zipcode").val() === "" || $("textarea.addr").val() === ""){
      this.errorTipsCom("tips","请填入必填项");

		}else {
			let subUrl = RequestUrl.subMitUserAddr($("input.name").val(),$("input.idCardNum").val(),$("input.phone").val(),$("textarea.addr").val(),$("input.zipcode").val(),$("textarea.note").val(),window.TVBoxInfo.partnerCode,window.TVBoxInfo.deMacCode,window.TVBoxInfo.token,window.TVBoxInfo.userid);
      let appUUI = $("input.name").val() +","+ $("input.phone").val() + "," + $("textarea.addr").val();//
      this.getPingBack(RequestUrl.getPBApp(window.TVBoxInfo.partnerCode,window.TVBoxInfo.macCode,window.TVBoxInfo.userid,"1","00101601","提交",appUUI));
			this.subAddr(subUrl);
		}

	}
  errorTipsCom = (pubType,errorTips) => {//封装公共接口请求错误提示
    let _this = this;
    _this.setState({
        pubType:pubType,
        errorTips:errorTips,
    },() => {
        setTimeout(()=>{
            _this.setState({
                pubType:"",
                errorTips:"",
            });
        },5000);
    });
  }
	getAddr = (url) => {
		HttpUtil.getP(url).then((json) => {
			console.log(json);
			if(json.code === "A000000"){
				btnCName = "submitBtn canSub";
				this.setState({
					nameValue: json.data.name,
					phoneValue: json.data.phoneNum,
					zipCode: json.data.zipCode,
					addrValue: json.data.address,
					noteValue: json.data.note,
          idCardNum: json.data.idCardNum,
				})
			}
		},(json) => {
        	console.log("fail");
    	});
	}
	subAddr = (url) => {
		HttpUtil.getP(url).then((json) => {
			console.log(json);
			if(json.code === "A000000"){
				this.onChangeHistory("/addrdet","?type=750&partnerCode="+window.TVBoxInfo.partnerCode+"&userId="+window.TVBoxInfo.userid+"&mac="+window.TVBoxInfo.macCode+"&token="+window.TVBoxInfo.token);
			}
		},(json) => {

    	});
	}
	onChangeHistory = (pathName, searchStr) => {
        this.props.history.replace({
            pathname: pathName,
            search: searchStr,
        })
    }
	render(){
		let isAddr = this.state.isHasAddr;
		// let popHtml = "";
		if(this.state.popType === 500){
			// popHtml = <PopWindow showPopType={this.state.popType} errorTips={this.state.errorTips} />
		}
		return (
			<div className="addrPage">
				<div className="title">
					请在下方输入<span>详细地址</span>，后期客服人员
				</div>
				<div className="title">将按照地址邮寄奖品</div>
				<div className="addrBox">
					<div className="head">我的收货地址</div>
					<div className="box">
						<div className="clearfix">
							<span>姓名</span>
							<input type="text" className="name" placeholder="必填选项" value={this.state.nameValue} onChange={this.onChange} />
						</div>
            <div className="clearfix">
							<span>身份证号</span>
							<input type="text" className="idCardNum" placeholder="非必填选项" value={this.state.idCardNum} onChange={this.onChange} />
						</div>
						<div className="clearfix">
							<span>联系电话</span>
							<input type="text" className="phone" placeholder="必填选项" value={this.state.phoneValue} onChange={this.onChange}/>
						</div>
						<div className="clearfix">
							<span>邮编</span>
							<input type="text" className="zipcode" placeholder="必填选项" value={this.state.zipCode} onChange={this.onChange} />
						</div>
						<div className="clearfix">
							<span>邮寄地址</span>
							<textarea type="text" className="addr" placeholder="请填写详细地址" value={this.state.addrValue} onChange={this.onChange}></textarea>
						</div>
					</div>
					<div className="remark">
						<div className="clearfix">
							<span>备注</span>
							<textarea type="note" className="note" placeholder="若有其他需要，请在此输入" value={this.state.noteValue} onChange={this.onChange}></textarea>
						</div>
					</div>
				</div>
				<div className={btnCName} onClick={this.onPress}></div>
      {
        this.state.pubType=="tips"?<div className="com-tips">{this.state.errorTips}</div>:""
      }
      {/*	{ popHtml }*/}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/component/inputAddr.js